import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

interface ExampleHintProps {
  title: string;
  children: React.ReactNode;
  /** Optional control: pass both to remember the open state somewhere (it still starts collapsed by default). */
  expanded?: boolean;
  onToggle?: (expanded: boolean) => void;
}

/** Collapsed-by-default explainer for someone who has not used the platform before. */
export const ExampleHint: React.FC<ExampleHintProps> = ({ title, children, expanded, onToggle }) => (
  <Accordion
    disableGutters
    {...(expanded !== undefined ? { expanded, onChange: (_event: React.SyntheticEvent, next: boolean) => onToggle?.(next) } : {})}
    sx={{ '&:before': { display: 'none' }, border: '1px solid', borderColor: 'divider', boxShadow: 'none' }}
  >
    <AccordionSummary expandIcon={<ExpandMore />}>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ pt: 0 }}>{children}</AccordionDetails>
  </Accordion>
);
